<ion-split-pane when="md" contentId="main-content" [ngClass]="platformService.menuIsCollapsed ? 'collapsed' : ''">
  <ion-menu contentId="main-content" class="{{selector}}-menu">
    <ion-grid>
      <ion-row class="ion-no-padding ion-margin-bottom">
        <ion-col>
          <img class="site-logo" [src]="platformService.menuIsCollapsed ? 'assets/images/logo.png' : 'assets/images/full_logo.png'">
        </ion-col>
      </ion-row>

      <ion-row class="ion-no-padding">
        <ion-col *ngIf="organizationId">
          <ng-container>
            <ion-list lines="none" class="ion-no-padding">
              <ion-menu-toggle auto-hide="false">
                <ion-item [routerLink]="['/org', organizationId, 'queue']" [detail]="false" [appActiveRoute]="'queue'" tooltip="Queues" [hideTooltip]="!platformService.menuIsCollapsed">
                  <ion-icon slot="start" name="unlink-outline"></ion-icon>
                  <ion-label [ngClass]="platformService.menuIsCollapsed ? 'ion-hide' : ''">Queues</ion-label>
                </ion-item>
              </ion-menu-toggle>
              <ion-menu-toggle auto-hide="false">
                <ion-item [routerLink]="['/org', organizationId, 'agents']" [detail]="false" [appActiveRoute]="'agents'" tooltip="Agents" [hideTooltip]="!platformService.menuIsCollapsed">
                  <ion-icon slot="start" name="people-outline"></ion-icon>
                  <ion-label [ngClass]="platformService.menuIsCollapsed ? 'ion-hide' : ''">Agents</ion-label>
                </ion-item>
              </ion-menu-toggle>
              <ion-menu-toggle auto-hide="false">
                <ion-item [routerLink]="['/org', organizationId, 'analytics']" [detail]="false" [appActiveRoute]="'analytics'" tooltip="Analytics" [hideTooltip]="!platformService.menuIsCollapsed">
                  <ion-icon slot="start" name="bar-chart-outline"></ion-icon>
                  <ion-label [ngClass]="platformService.menuIsCollapsed ? 'ion-hide' : ''">Analytics</ion-label>
                </ion-item>
              </ion-menu-toggle>
            </ion-list>
          </ng-container>
        </ion-col>
      </ion-row>

      <ion-row class="ion-no-padding">
        <ion-col>
          <ion-list class="ion-no-padding">
            <ion-item lines="full" class="ion-no-margin ion-padding-bottom" [detail]="false" (click)="platformService.toggleMenu()" *ngIf="!platformService.isMobile">
              <ion-icon slot="start" [name]="(platformService.menuIsCollapsed ? 'hp-chevron-expandible-' : 'hp-chevron-collapsible-') + platformService.themeMode"></ion-icon>
            </ion-item>
            <ion-item class="pointer" lines="none" [detail]="false" (click)="onOpenSupportModal(true)" [appActiveRoute]="'support'" tooltip="Support" [hideTooltip]="!platformService.menuIsCollapsed">
              <ion-icon slot="start" name="help-circle-outline"></ion-icon>
              <ion-label [ngClass]="platformService.menuIsCollapsed ? 'ion-hide' : ''">Support</ion-label>
            </ion-item>
          </ion-list>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-menu>

  <div class="ion-page {{selector}}-page" id="main-content">
    <ion-header>
      <ion-toolbar>
        <ion-title>{{header}}</ion-title>

        <ion-buttons slot="end">
          <ion-chip ngClass="account-chip" id="tenant-chip">
            <ion-label class="ion-hide-sm-down">{{organizationName}}</ion-label>
            <ion-icon *ngIf="organizations.length > 1" [name]="'hp-chevron-down-' + platformService.themeMode" size="small"></ion-icon>
          </ion-chip>
          <ion-button class="theme-toggle-button" (click)="platformService.toggleTheme()">
            <ion-icon slot="icon-only" [name]="platformService.themeMode === 'dark' ? 'sunny' : 'moon'" size="small" color="medium"></ion-icon>
          </ion-button>
          <ion-chip class="account-chip" id="account-chip">
            <ion-avatar>
              <img alt="Avatar" src="assets/images/avatar.svg" />
            </ion-avatar>
            <ion-label class="ion-hide-sm-down">{{principal.firstName}} {{principal.lastName}}</ion-label>
            <ion-icon [name]="'hp-chevron-down-' + platformService.themeMode" size="small"></ion-icon>
          </ion-chip>
        </ion-buttons>
        <ion-popover trigger="tenant-chip" triggerAction="click" [dismissOnSelect]="true" showBackdrop="false" *ngIf="organizations.length > 1">
          <ng-template>
            <ion-content>
              <ion-list lines="none">
                <ion-item *ngFor="let org of organizations" [button]="true" [detail]="false" [appActiveItem]="org.name === organizationName" (click)="changeOrganization(org.id)">
                  <ion-label>{{org.name}}</ion-label>
                </ion-item>
              </ion-list>
            </ion-content>
          </ng-template>
        </ion-popover>
        <ion-popover trigger="account-chip" triggerAction="click" [dismissOnSelect]="true" showBackdrop="false">
          <ng-template>
            <ion-content>
              <ion-list lines="none">
                <ion-item [button]="true" [detail]="false" (click)="onOpenLogoutModal(true)" [appActiveRoute]="''">
                  <ion-icon name="exit-outline" size="small" slot="start"></ion-icon>
                  <ion-label>Logout</ion-label>
                </ion-item>
              </ion-list>
            </ion-content>
          </ng-template>
        </ion-popover>
      </ion-toolbar>
    </ion-header>

    <ion-content class="ion-padding">
      <ion-router-outlet id="main"></ion-router-outlet>
    </ion-content>
  </div>
</ion-split-pane>
<app-logout-modal [open]="openLogoutModal" (dismiss)="onOpenLogoutModal(false)"></app-logout-modal>
<app-support-modal [tenantId]="organizationId" [open]="openSupportModal" (dismiss)="onOpenSupportModal(false)"></app-support-modal>
